import type { IntentResult } from '@finos/fdc3';
import type { DownEventData } from '@/common/interop/down-messages';

const intentResultListeners = new Map<
  string,
  Set<(result: IntentResult) => void>
>();

export function handleIntentResult(event: DownEventData['intentResultEvent']) {
  const listeners = intentResultListeners.get(event.eventId);
  listeners?.forEach((listener) => listener(event.result as IntentResult));
}

function addIntentResultListener(
  eventId: string,
  listener: (result: IntentResult) => void,
) {
  if (!intentResultListeners.has(eventId)) {
    intentResultListeners.set(eventId, new Set());
  }
  intentResultListeners.get(eventId)?.add(listener);
}

function removeIntentResultListener(
  eventId: string,
  listener: (result: IntentResult) => void,
) {
  intentResultListeners.get(eventId)?.delete?.(listener);
}

export function waitForIntentResult(eventId: string) {
  return new Promise<IntentResult>((res) => {
    const listener = (result: IntentResult) => {
      res(result);
      removeIntentResultListener(eventId, listener);
    };
    addIntentResultListener(eventId, listener);
  });
}
